
import * as React from 'react';
import styled from 'styled-components';

import { EventLogGrid } from '@process-advisor/process-miner/eventLog/eventLogGrid';
import { TransformationGrid } from '@process-advisor/process-miner/eventLog/transformationGrid';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { SingleBlock} from '@process-advisor/process-miner/components/layout/singleBlock';
import { Button } from '@process-advisor/process-miner/components/shared/button';
import { getShadow, getZIndex,getColor, getFontSize } from '@process-advisor/process-miner/shared/theme';

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
    margin-top: 15px;
`;

const Label = styled.div`
    font-size: ${getFontSize('small')};
    color: ${getColor('blue')};
    margin-top: 12px;
    text-align: left;
    width: 100%;
`;

type Props = {
  nextDisabled: (value: boolean) => void;
  step: number;
}

function fileToText(file, callback) {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () => {
        callback(reader.result);
    };
}

export const EventLog: React.FC<Props> = ({
  nextDisabled,
  step,
}) => {
    const [saveDisabled,setSaveDisabled] = React.useState<boolean>(true);
    const [deleteDisabled,setDeleteDisabled] = React.useState<boolean>(true);

    const loadTransformation = () => {
        const inputFile = document.createElement('input');
        inputFile.type = 'file';
        inputFile.click();
        inputFile.addEventListener('change', () => {
            const file = inputFile.files[0];
            fileToText(file, (text) => {
                apiProvider.importTransformation({ importedTransformation: text })
            });
        });
        apiProvider.alertMessage({message: 'Transformation loaded', severity: 'success', showAlert: true, timeOutActive: true, component: 'event_log_transformation'} );
    };

    const saveTransformation = () => {
        apiProvider.saveTransformation({});
        apiProvider.alertMessage({message: 'Transformation saved', severity: 'success', showAlert: true, timeOutActive: true, component: 'event_log_transformation'} );
    };

    const resetTransformation = () => {
        apiProvider.resetTransformation({});
        setDeleteDisabled(true)
        setSaveDisabled(true)
    };

    const deleteTransformation = () => {
        setDeleteDisabled(true)
        apiProvider.deleteTransformationRow({});
    };

    return (
        <Wrapper>
            <SingleBlock>
                <Label>Click ☰ to map a column and select the data type</Label>
            </SingleBlock>
            <SingleBlock>
                <EventLogGrid/>
            </SingleBlock>
            <SingleBlock>
                <TransformationGrid step={step} setSaveDisabled={setSaveDisabled} setDeleteDisabled={setDeleteDisabled} setNextDisabled={nextDisabled}/>
            </SingleBlock>
            <SingleBlock width="25%">
                <Button label='Delete Transformation' onClick={deleteTransformation} disabled={deleteDisabled}/>
            </SingleBlock>
            <SingleBlock width="25%">
                <Button label='Reset Transformation' onClick={resetTransformation} disabled={saveDisabled}/>
            </SingleBlock>
            <SingleBlock width="25%">
                <Button label='Save Transformation' onClick={saveTransformation} disabled={saveDisabled}/>
            </SingleBlock>
            <SingleBlock width="25%">
                <Button label='Load Transformation' onClick={loadTransformation} />
            </SingleBlock>          
        </Wrapper>
    );
};
